import '@web-components/predictive-search';
import '@web-components/drawer';

function insertTriggers() {
  const searchLinks = document.querySelectorAll<HTMLAnchorElement>('a[href*="/search"]:not([href*="page="])');
  searchLinks.forEach((link) => {
    if (link.parentElement?.tagName === 'DRAWER_TRIGGER') return;
    const clonedLink = link.cloneNode(true) as HTMLAnchorElement;
    const drawerTrigger = document.createElement('drawer-trigger');
    drawerTrigger.setAttribute('action', 'open');
    drawerTrigger.setAttribute('on', 'click');
    drawerTrigger.setAttribute('target', '#searchNavigationDrawer');
    drawerTrigger.setAttribute('prevent-default', 'true');
    drawerTrigger.append(clonedLink);

    link.replaceWith(drawerTrigger);
  });
}

insertTriggers();